module.exports = __webpack_public_path__ + "static/media/yourdata_05.394421e5.jpg";